import { Component, computed, input, signal } from '@angular/core';
import { Navlink } from '@shared/models/navlink.model';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
  navLinks = input.required<Navlink[]>();
  pharmacies = input<Navlink[]>();
  chains = input<Navlink[]>();
  bottomLinks = input<Navlink[]>();
  isLoading = input<boolean>(false);
  isClosed = input<boolean>(false);
  loadingCount = input<number>(0);

  pharmacySearch = signal('');
  chainSearch = signal('');

  pharmacySearchEnabled = computed<boolean>(() => (this.pharmacies() ?? []).length > 10);
  chainSearchEnabled = computed<boolean>(() => (this.chains() ?? []).length > 10);

  filteredPharmacies = computed<Navlink[]>(() => (this.pharmacies() ?? []).filter(this.filterLinkByLowercase(this.pharmacySearch())));
  filteredChains = computed<Navlink[]>(() => (this.chains() ?? []).filter(this.filterLinkByLowercase(this.chainSearch())));
  placeHolderItems = computed(() => Array.from(Array(this.loadingCount()).keys()));

  private filterLinkByLowercase(searchString: string): (link: Navlink) => boolean {
    if (searchString === '') {
      return () => true;
    }
    return link => {
      if (link.subLabel) {
        if (link.subLabel.toLowerCase().includes(searchString.toLowerCase())) return true;
      }
      return (link.subLabel || link.label).toLowerCase().includes(searchString.toLowerCase());
    };
  }
}
